import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.71 28.29L21.45 20A11 11 0 1020 21.45l8.25 8.26a1 1 0 001.42 0 1 1 0 00.04-1.42zM13 22a9 9 0 119-9 9 9 0 01-9 9z"/><path d="M18 12H8a1 1 0 000 2h10a1 1 0 000-2z"/>';
export var ZoomOutOutlineSVG = function ZoomOutOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ZoomOutOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ZoomOutOutlineSVG);